import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, User } from 't4core';
import { FormControl } from '@angular/forms';
import { Observable, from } from 'rxjs';

@Component({
  selector: 't4-findUserDialog',
    templateUrl: 'FindUserDialog.html',
})
export class FindUserDialog extends DialogBase {
    public txtUser = new FormControl();
    public selectedUser: User;
    public filteredUsers: Observable<User[]>;

    constructor(public dialogRef: MatDialogRef<FindUserDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
      super("FindUserDialog");

      this.txtUser.valueChanges.subscribe(x => {
          this.filteredUsers = from(this.Api.get<User[]>("/Settings/FilterUsers", { searchText: x, limit: 50 }));
      });

  }

    public async selectUser(item) {
        console.log(item);
        this.selectedUser = item;
        //this.data = this.selectedUser;
    }

    public async confirm() {
        this.data = this.selectedUser;
    }
}
